<form class="modal-content" [formGroup]="form" (ngSubmit)="onSubmit()" aria-describedby="required-fields-note">
  <div class="modal-header">
    <div class="modal-header-left">
      <h4 class="modal-title">{{ isUpdate ? "Edit" : "Add" }} Table</h4>
    </div>
    <div class="modal-header-right">
      <button type="button" class="close" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="modal-body-inner">
      <div class="required-fields-explanation" role="note" tabindex="-1" id="required-fields-note">
        <p><span class="text-danger" aria-hidden="true">*</span> Indicates required fields</p>
      </div>
      <div class="form-custom-div">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <app-input
              [form]="form"
              label="Table Name"
              controlName="Name"
            ></app-input>
          </div>
          <div class="col-lg-12 col-md-12">
            <app-input
              [form]="form"
              label="Singular Name"
              controlName="SingularReference"
            ></app-input>
          </div>
          <div class="col-lg-12 col-md-12">
            <div class="form-group">
              <label>Logo</label>
              <div class="default-icon-list-div">
                <div class="default-icon-list-root">
                  <!-- <div
                    class="custom-radio-icons-box"
                    *ngFor="let icon of icons; let i = index"
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="logo"
                      [id]="'custom-icons' + i"
                      [value]="iconBaseURL + icon"
                      formControlName="logo"
                      (change)="
                        clearDragUpload.next(); uriToFile(iconBaseURL + icon)
                      "
                    />
                    <label
                      class="custom-control-label"
                      [for]="'custom-icons' + i"
                    >
                      <span class="custom-check-round">
                        <span class="img-thumb dark-back">
                          <img
                            [src]="iconBaseURL + icon"
                            class="img-fluid img-default-icon dark-back"
                            alt="default-icon"
                          />
                        </span>
                      </span>
                    </label>
                  </div> -->
                  <app-icons
                    class="w-100"  
                    fontSize="40"
                    height="350"
                    [form]="form"
                  ></app-icons>
                </div>
              </div>
              <div class="or-div" *ngIf="isUpdate"><span class="text-or">or</span></div>
              <div class="d-flex justify-content-center" *ngIf="isUpdate">
                <button _ngcontent-xkl-c448="" type="button" class="btn btn-info ml-2 btn-clear-logo" (click)="resetLogo()"> Clear Logo </button>
              </div>
              <div class="or-div"><span class="text-or">or</span></div>
              <app-drag-upload
                title=""
                subTitle=""
                (value)="dragFileEvent($event)"
                mime="image/*"
                [clear]="clearDragUpload"
              ></app-drag-upload>
              <image-cropper
                [imageBase64]="imageChangedEvent"
                [maintainAspectRatio]="false"
                [aspectRatio]="4 / 4"
                [resizeToWidth]="256"
                format="png"
                (imageCropped)="imageCropped($event)"
              >
              </image-cropper>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer-bottom">
      <app-modal-action-btns
        [confirmTitle]="isUpdate ? 'Update' : 'Add'"
        (onReject)="close()"
        [form]="form"
      ></app-modal-action-btns>
    </div>
  </div>
</form>
